import sortBy from 'lodash/sortBy';
import HttpService from '../../../common/http/HttpService';
import SystemManagementEndpoint from '../const/SystemManagementEndpoint';
import EventService from '../../../common/event/EventService';
import SystemManagementEvent from '../const/SystemManagementEvent';
import makeMoment from '../../../common/moment/MomentFactory';

async function listSystems(systemFilter) {
  const response = await HttpService.post(
    SystemManagementEndpoint.LIST_SYSTEMS,
    { systemFilter },
  );

  const systems = response.data;
  return sortBy(systems, 'name');
}

async function activate(systemIds) {
  await HttpService.post(SystemManagementEndpoint.ACTIVATE, { systemIds });
  EventService.dispatch(SystemManagementEvent.SYSTEM_STATUS_UPDATED);
}

async function deactivate(systemIds) {
  await HttpService.post(SystemManagementEndpoint.DEACTIVATE, { systemIds });
  EventService.dispatch(SystemManagementEvent.SYSTEM_STATUS_UPDATED);
}

function updateAutoActivationCmms(autoActivation) {
  if (autoActivation === true) {
    HttpService.post(SystemManagementEndpoint.ACTIVATE_AUTO_ACTIVATION);
    return;
  }
  HttpService.post(SystemManagementEndpoint.DEACTIVATE_AUTO_ACTIVATION);
}

async function getAutoActivationCmms() {
  const response = await HttpService.get(SystemManagementEndpoint.AUTO_ACTIVATION);
  return response.data;
}

async function isTestPartner() {
  const response = await HttpService.get(SystemManagementEndpoint.GET_TEST_PARTNER);
  return response.data;
}

function isSystemActive(data) {
  if (data.activeUntil === null) {
    return true;
  }
  const activeUntil = makeMoment(data.activeUntil);
  const now = makeMoment.utc();

  return activeUntil.isSameOrAfter(now);
}

const SystemManagementService = {
  listSystems,
  activate,
  deactivate,
  updateAutoActivationCmms,
  getAutoActivationCmms,
  isTestPartner,
  isSystemActive,
};

export default SystemManagementService;
